const privadosRoutes = [
  {
    path: "/privados",
    name: "privados",
    component: () => import(/* webpackChunkName: "privados-page" */ "@/modules/privados/views/PrivadosPage.vue"),
  },
];

export default privadosRoutes;
